export const LOGGING_EVENTS = {
  CLICK_CLOSE_EMERGENCY_WARNING:
    'user_action.location_page.appt_info.emergency_warning.close_warning',
  CLICK_EMERGENCY_WARNING:
    'user_action.location_page.appt_info.emergency_warning.click_warning',
  PROVIDER_TIMESLOT_SELECTED:
    'user_action.provider_timeslot_selected_location_page'
} as const;
